'use client';

import { c as _c } from "react/compiler-runtime";
import { useTheme } from 'next-themes';
import { Toaster as Sonner } from 'sonner';
type ToasterProps = React.ComponentProps<typeof Sonner>;
const Toaster = t0 => {
  const $ = _c(6);
  let props;
  if ($[0] !== t0) {
    ({
      ...props
    } = t0);
    $[0] = t0;
    $[1] = props;
  } else {
    props = $[1];
  }
  const {
    theme: t1
  } = useTheme();
  const theme = t1 === undefined ? "system" : t1;
  const t2 = theme as ToasterProps['theme'];
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      classNames: {
        actionButton: "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
        cancelButton: "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        description: "group-[.toast]:text-muted-foreground",
        toast: "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg"
      }
    };
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== props || $[4] !== t2) {
    t4 = <Sonner className="toaster group" theme={t2} toastOptions={t3} {...props} />;
    $[3] = props;
    $[4] = t2;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  return t4;
};
export { Toaster };